import http from '@/utils/http-util'
import { bladeXUrl } from '/env'

// let BladeAuth = 'bearer 2eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5hbnRfaWQiOiIwMDAwMDAiLCJ1c2VyX25hbWUiOiJhZG1pbiIsInJlYWxfbmFtZSI6IueuoeeQhuWRmCIsImF2YXRhciI6Imh0dHBzOi8vZ3cuYWxpcGF5b2JqZWN0cy5jb20vem9zL3Jtc3BvcnRhbC9CaWF6ZmFueG1hbU5Sb3h4VnhrYS5wbmciLCJhdXRob3JpdGllcyI6WyJhZG1pbmlzdHJhdG9yIiwiYm9zcyJdLCJjbGllbnRfaWQiOiJzYWJlciIsInJvbGVfbmFtZSI6ImFkbWluaXN0cmF0b3IsYm9zcyIsImxpY2Vuc2UiOiJwb3dlcmVkIGJ5IGJsYWRleCIsInBvc3RfaWQiOiIxMTIzNTk4ODE3NzM4Njc1MjAxIiwidXNlcl9pZCI6IjExMjM1OTg4MjE3Mzg2NzUyMDEiLCJyb2xlX2lkIjoiMTEyMzU5ODgxNjczODY3NTIwMSwxMTIzNTk4ODE2NzM4Njc1MjA1Iiwic2NvcGUiOlsiYWxsIl0sIm5pY2tfbmFtZSI6IueuoeeQhuWRmCIsImF0aSI6IjNiZTY5NmRmLTNiMmYtNDFlNC05ZmM1LWExZGU1NGIzM2U4NyIsIm9hdXRoX2lkIjoiIiwiZGV0YWlsIjp7InR5cGUiOiJ3ZWIifSwiZXhwIjoxNzA5NzIwNTA5LCJkZXB0X2lkIjoiMTEyMzU5ODgxMzczODY3NTIwMSIsImp0aSI6ImQ0NTFkYzg3LTg5YzMtNDMyYy05ZDUyLWEyNzVhODUwNTM3ZSIsImFjY291bnQiOiJhZG1pbiJ9.lFrxMUujCfbjgMZyee7ofUL1BzF4XWeKNR2BwJJEGOY'
// const params = {
//     Authorization: 'Basic c2FiZXI6c2FiZXJfc2VjcmV0',
//     'Blade-Auth': BladeAuth,
//     'Tenant-Id': '000000'
// }

export const request = (httpParams) => {
    const singleSignOnJSON = localStorage.getItem('singleSignOn')
    const singleSignOn = singleSignOnJSON ? JSON.parse(singleSignOnJSON) : {}
    console.log(singleSignOn)
    let config = {
        ...httpParams,
        headers: {
            Authorization: 'Basic c2FiZXI6c2FiZXJfc2VjcmV0',
            // Authorization: 'Basic c2FiZXI6c2FiZXJfc2VjcmV0',
            // 'Blade-Auth': 'bearer ' + singleSignOn?.refresh_token,
            'Tenant-Id': '000000',
        }
    }
    if(singleSignOn?.refresh_token) {
        config.headers['Blade-Auth'] = 'bearer ' + singleSignOn?.refresh_token
    }
    return http(config)
}

/**
 * 获取下拉数据源
 * @returns JSON
 */
export function getDataSourceSelect() {
    return request({
        url: bladeXUrl + '/blade-develop/datasource/select',
        method: 'get'
    })
}

/**
 * 查询所有表
 * @param {Number} datasourceId 数据源id
 * @returns JSON
 */
export function getAllTableList(datasourceId) {
    return request({
        url: bladeXUrl + '/blade-develop/model/all-table-list',
        method: 'get',
        params: {
            datasourceId,
        }
    })
}

/**
 * 获取表字段
 * @param {Object} param0 
 * @param {Number} param.datasourceId 数据源id
 * @param {String} param.tableName 表名
 * @returns JSON
 */
export function getTableField({ datasourceId, tableName }) {
    return request({
        url: bladeXUrl + '/blade-develop/model/table-field',
        method: 'get',
        params: {
            datasourceId, tableName,
        }
    })
}

/**
 * 传入对象执行自定义sql!
 * @param {Object} param0 
 * @param {Number} param.datasourceId 数据源id
 * @param {String} param.tableName 表名
 * @returns JSON
 */
export function execSqlData({ datasourceId, param }) {
    console.log(datasourceId, 'datasourceIddatasourceIddatasourceIddatasourceId')
    return request({
        url: bladeXUrl + `/blade-logic/logic-api/exec-sql-data?datasourceId=${datasourceId}`,
        method: 'post',
        data: param
    })
}

/**
 * 删除自定义qsl!
 * @param {Object} param0 
 * @param {Number} param.datasourceId 数据源id
 * @param {String} param.tableName 表名
 * @returns JSON
 */
export function execSqlDeleteData({ datasourceId, param }) {
    return request({
        url: bladeXUrl + `/blade-logic/logic-api/exec-sql-delete?datasourceId=${datasourceId}`,
        method: 'post',
        data: param
    })
}


/**
 * @title 逻辑编排 - 列表类型
 * @returns JSON
 */
export function logicEngineGroup(param) {
    return request({
        url: bladeXUrl + `/blade-logic/group/page`,
        method: 'get',
        params: param
    })
}

/**
 * @title 逻辑编排 - 列表
 * @returns JSON
 */
export function logicEnginePage(param) {
    return request({
        url: bladeXUrl + `/blade-logic/logic/page`,
        method: 'get',
        params: param
    })
}

/**
 * @title 逻辑编排 - 详情 
 * @returns JSON
 */
export function logicEngineDetail(param) {
    return request({
        url: bladeXUrl + `/blade-logic/logic/detail`,
        method: 'get',
        params: param
    })
}

/**
 * @title 逻辑编排 - 执行
 */
export function logicEngineRun(id, data) {
    return request({
        url: bladeXUrl + `/blade-logic/logic/run/${id}`,
        method: 'post',
        data
    })
}





export function reloadLogin() {
    const singleSignOn = localStorage.getItem('singleSignOn')
    const userinfo = singleSignOn ? JSON.parse(singleSignOn) : {}

    return request({
        url: bladeXUrl + `/blade-auth/oauth/token`,
        method: 'post',
        data: {
            grant_type: 'refresh_token',
            scope: 'all',
            deptId: userinfo?.dept_id,
            roleId: userinfo?.role_id,
            tenantId: '000000',
            refresh_token: userinfo?.refresh_token
        },
    })
}

